export default __webpack_public_path__ + "static/parallel-e33acbc28a71c570d2ada0ede9a83a3e.png";